{
	"title": "Gestion des partenaires",
	"description": "Liste et enregistrement des clients et fournisseurs.",
	"pixKeyCopiedSuccess": "Clé PIX copiée avec succès !",
	"pixKeyCopyError": "Erreur lors de la copie de la clé PIX",
	"name": "Nom / Nom commercial",
	"customerName": "Nom",
	"namePlaceholder": "Saisissez le nom commercial/nom abrégé",
	"customerNamePlaceholder": "Saisissez le nom",
	"legalName": "Raison sociale",
	"legalNamePlaceholder": "Saisissez la raison sociale/nom complet",
	"cpfOrCnpj": "CPF/CNPJ",
	"cpfOrCnpjPlaceholder": "Entrez le CPF/CNPJ",
	"inscricaoEstadual": "Inscription d'État",
	"inscricaoEstadualPlaceholder": "Entrez l'inscription d'État",
	"cep": "Code postal",
	"cepPlaceholder": "Entrez le code postal",
	"state": "État",
	"statePlaceholder": "Entrez l'état",
	"city": "Ville",
	"cityPlaceholder": "Entrez la ville",
	"street": "Adresse",
	"streetPlaceholder": "Entrez l'adresse",
	"streetNumber": "Numéro",
	"streetNumberPlaceholder": "Entrez le numéro",
	"complemento": "Complément",
	"complementoPlaceholder": "Entrez le complément",
	"neighborhood": "Quartier",
	"neighborhoodPlaceholder": "Entrez le quartier",
	"bank": "Banque",
	"bankPlaceholder": "Entrez la banque",
	"agency": "Agence",
	"agencyPlaceholder": "0000",
	"account": "Compte",
	"accountPlaceholder": "Entrez le compte",
	"ownerName": "Nom du propriétaire",
	"ownerNamePlaceholder": "Entrez le nom du propriétaire du compte",
	"bankcpfOrCnpj": "CPF/CNPJ",
	"bankcpfOrCnpjPlaceholder": "Entrez le CPF/CNPJ du propriétaire",
	"phone": "Téléphone fixe",
	"cellPhone": "Téléphone portable",
	"email": "E-mail",
	"placeholderPhone": "(00) 0000-0000",
	"placeholderCellPhone": "(00) 0 0000-0000",
	"placeholderEmail": "exemple@email.com",
	"validateField": "Champ obligatoire",
	"chartOfAccounts": "Plan comptable",
	"chartOfAccountsPlaceholder": "Sélectionnez le plan",
	"wishToAdd": "Souhaitez-vous ajouter ?",
	"popConfirm": "Voulez-vous vraiment supprimer cet élément ?",
	"notInformed": "Non informé",
	"address": "Adresse",
	"actions": "Actions",
	"type": "Taper",
	"addNewRegister": "Enregistrer partenaire",
	"editRegister": "Modifier partenaire",
	"generalData": "Données Générales",
	"bankData": "Coordonnées bancaires",
	"bankAccount": "Compte bancaire",
	"searchPlaceholder": "Rechercher par client, fournisseur, employé",
	"messages": {
		"pixKeyCopiedSuccess": "Clé PIX copiée avec succès !",
		"pixKeyCopyError": "Erreur lors de la copie de la clé PIX"
	},
	"labels": {
		"pixKeyTypeUppercase": "TYPE DE CLÉ PIX",
		"pixKeyUppercase": "CLÉ PIX",
		"cpfCnpjUppercase": "CPF/CNPJ",
		"copyPixKey": "Copier la clé PIX"
	},
	"infoMessage": "Le type d'inscription permet de paramétrer les documents financiers utilisés par un client, un fournisseur ou les deux.",
	"registerTypes": {
		"client": "Client",
		"supplier": "Fournisseur",
		"customerAndSupplier": "Client et fournisseur",
		"employee": "Employé"
	},
	"allPartners": "Tous les partenaires",
	"selectRegistrationType": "Type de partenaire",
	"modalWarningCancel": {
		"title": "Annuler les modifications"
	},
	"confirmCancelRegistration": {
		"title": "Annuler l'inscription",
		"message": "Vous créez une inscription de partenaire. Êtes-vous sûr de vouloir annuler?",
		"confirmText": "Continuer l'inscription",
		"cancelText": "Annuler"
	},
	"invalidAgency": "Agence invalide",
	"invalidAccount": "Compte invalide",
	"invalidZipCode": "Code postal invalide",
	"invalidEmail": "Email invalide",
	"supplierDetails": "Détails du fournisseur",
	"customerDetails": "Détails du client",
	"employeeDetails": "Détails de l'employé",
	"customerAndSupplierDetails": "Détails du client et fournisseur",
	"viewDetails": "Voir les détails",
	"pixKeyType": "Type de Clé PIX",
	"pixKeyTypePlaceholder": "Sélectionnez le type",
	"pixKey": "Clé PIX",
	"pixKeyPlaceholder": "Entrez la clé PIX",
	"pixKeyTypes": {
		"cpf": "CPF",
		"cnpj": "CNPJ",
		"email": "Courriel",
		"phone": "Téléphone",
		"evp": "Clé Aléatoire"
	},
	"pixKeyPlaceholders": {
		"cpf": "000.000.000-00",
		"cnpj": "00.000.000/0000-00",
		"email": "exemple@email.com",
		"phone": "(00) 00000-0000",
		"evp": "Clé aléatoire (UUID)"
	},
	"errors": {
		"unknown": "Erreur inconnue",
		"validationErrors": "Erreurs de validation :",
		"clearFieldError": "Effacer l'erreur du champ",
		"cpfInvalid": "CPF invalide",
		"cnpjInvalid": "CNPJ invalide",
		"cpfMustHaveDigits": "Le CPF doit avoir 11 chiffres",
		"cnpjMustHaveDigits": "Le CNPJ doit avoir 14 chiffres",
		"emailInvalid": "E-mail invalide",
		"phoneMustHaveDigits": "Le téléphone doit avoir 10 ou 11 chiffres",
		"randomKeyInvalidChars": "La clé PIX ne doit contenir que des chiffres, des lettres et des tirets",
		"randomKeyInvalidLength": "La clé PIX aléatoire doit avoir le format correct de 36 caractères",
		"randomKeyInvalidFormat": "Clé PIX invalide. Vérifiez si vous l'avez copiée correctement de votre banque"
	},
	"fieldNames": {
		"id": "ID",
		"name": "Nom",
		"legalName": "Raison Sociale",
		"inscricaoEstadual": "Inscription d'État",
		"cpfOrCnpj": "CPF/CNPJ",
		"street": "Rue",
		"streetNumber": "Numéro",
		"complemento": "Complément",
		"cep": "Code Postal",
		"state": "État",
		"city": "Ville",
		"neighborhood": "Quartier",
		"bank": "Banque",
		"agency": "Agence",
		"account": "Compte",
		"bankcpfOrCnpj": "CPF/CNPJ",
		"ownerName": "Nom du Titulaire",
		"phone": "Téléphone",
		"email": "Courriel",
		"cellPhone": "Téléphone portable",
		"registerType": "Type d'Enregistrement",
		"pixKeyType": "Type de Clé PIX",
		"pixKey": "Clé PIX"
	},
	"form": {
		"contactAndAddressSubtitle": "Informations de contact et adresse",
		"saving": "Enregistrement...",
		"maxAttemptsReached": "Nombre maximum de tentatives atteint ({current}/{max})",
		"waitCooldown": "Attendez {seconds}s",
		"reset": "Réinitialiser",
		"submissionBlockedTooltip": "Soumission bloquée - Tentatives : {current}/{max}",
		"cooldownTooltip": "Temps d'attente : {seconds}s"
	}
}
